import 'rsuite/dist/rsuite.css';
import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import 'rsuite/dist/rsuite.css';
import '../../../styles/reskinned-task-list.css';

import { Table, Tag, IconButton } from 'rsuite';
import CollaspedOutlineIcon from '@rsuite/icons/CollaspedOutline';
import ExpandOutlineIcon from '@rsuite/icons/ExpandOutline';
import { FaEdit, FaTrash } from 'react-icons/fa';
import {
  Badge,
  Select,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from '@chakra-ui/react';
import {
  Table as NexusTable,
  TableHead,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TableActionsCell,
  TableHeaderSortCell,
  TableSortDirection,
  Button as NexusButton,
  Modal as NexusModal,
  ModalBody as NexusModalBody,
  ModalFooter as NexusModalFooter,
  IconButton as NexusIconButton,
  useNexus,
  Tag as NexusTag,
  ActionMenu,
  showToast,
} from '@spotoninc/nexus-react';
import {
  EditIcon,
  DeleteIcon,
  MoreVerticalIcon,
} from '@spotoninc/nexus-web-assets';
import { useFeatureFlagFromContext } from '../../../launchdarkly';
import TaskDrawer from '../dashboard/TaskDrawer';
import { fetchWithAuth } from '../../../utils/apiHelpers';
import { trackTaskStatusChanged } from '../../../utils/analytics/taskTracking';
//import { Select } from "chakra-react-select";

// Import SVG images needed for the TaskDrawer
import completedSvg from '../../../media/images/completed-status.svg';
import cancelledSvg from '../../../media/images/cancelled-status.svg';
import inProgressSvg from '../../../media/images/in-progress.svg';
import todoSvg from '../../../media/images/todo.svg';
import statusSvg from '../../../media/images/status.svg';
import deleteIconSvg from '../../../media/images/delete-icon.svg';
import listNumberIconSvg from '../../../media/images/list-number-icon.svg';

const { Column, HeaderCell, Cell } = Table;

const rowKey = 'id';

// Function to process task values in QA environment
const processTaskValue = value => {
  // Check if we're in QA environment
  if (
    process.env.REACT_APP_ENV === 'qa' &&
    value &&
    typeof value === 'string'
  ) {
    // Remove the word 'balance' (case insensitive) from the task value
    return value.replace(/balance\s*/i, '');
  }
  return value;
};

// Original TaskTable component
function OriginalTaskTable(props) {
  const [MisOpen, setMisOpen] = useState(false);
  const [ModalRowData, setModalRowData] = useState(false);

  const ExpandCell = ({
    rowData,
    dataKey,
    expandedRowKeys,
    onChange,
    onClick,
    ...props
  }) => (
    <Cell {...props} style={{ padding: 5 }}>
      <IconButton
        appearance="subtle"
        onClick={() => {
          onClick(rowData);
        }}
        icon={
          expandedRowKeys.some(key => key === rowData[rowKey]) ? (
            <CollaspedOutlineIcon />
          ) : (
            <ExpandOutlineIcon />
          )
        }
      />
    </Cell>
  );

  const handleDel = id => {
    props.handleDel(id);
  };

  const renderRowExpanded = rowData => {
    return (
      <Flex direction={'column'} gap={2} height={'auto'}>
        <Flex
          justifyContent={'left'}
          p={2}
          gap={1}
          direction={'column'}
          flex={1}
        >
          <Heading size={'sm'}>Description</Heading>
          <Text fontSize={'xs'} maxWidth={1000} noOfLines={1}>
            {processTaskValue(rowData.description)}
          </Text>
        </Flex>
        <Flex gap={3} justify={'end'} width="100%" flex={1}>
          <Button
            bgColor={'#faac35'}
            fontSize={'xs'}
            gap={2}
            size={'xs'}
            onClick={() => {
              if (rowData.status === 'Not yet Started') {
                setMisOpen(true);
                setModalRowData(rowData);
              } else {
                alert('Task cant be Edited.');
              }
            }}
          >
            <Icon as={FaEdit} />
            Edit Task
          </Button>
          <Button
            bgColor={'#faac35'}
            fontSize={'xs'}
            gap={2}
            onClick={() => {
              if (rowData.status === 'Not yet Started') {
                handleDel(rowData.id);
              } else {
                alert('Task cant be deleted.');
              }
            }}
            size={'xs'}
          >
            <Icon as={FaTrash} />
            Delete Task
          </Button>
        </Flex>
      </Flex>
    );
  };

  const [expandedRowKeys, setExpandedRowKeys] = React.useState([]);
  const TagCell = ({ rowData, dataKey, ...props }) => {
    <Cell {...props} style={{ padding: '2' }}>
      <Tag color="green">{rowData[dataKey]}</Tag>
    </Cell>;
  };

  const handleExpanded = (rowData, dataKey) => {
    let open = false;
    const nextExpandedRowKeys = [];

    expandedRowKeys.forEach(key => {
      if (key === rowData[rowKey]) {
        open = true;
      } else {
        nextExpandedRowKeys.push(key);
      }
    });

    if (!open) {
      nextExpandedRowKeys.push(rowData[rowKey]);
    }

    setExpandedRowKeys(nextExpandedRowKeys);
  };

  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [loading, setLoading] = React.useState(props.loading);

  const getData = value => {
    if (sortColumn && sortType) {
      return value.data.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === 'string') {
          x = x.charCodeAt();
        }
        if (typeof y === 'string') {
          y = y.charCodeAt();
        }
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }

    return value.data;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    props.setLoading(true);
    if (sortColumn === 'dueDate') {
      props.retrieveData(sortType);

      setSortColumn(sortColumn);
      setSortType(sortType);
    } else {
      setTimeout(() => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        props.setLoading(false);
      }, 500);
    }
  };

  if (props) {
    return (
      <>
        <Modal
          isOpen={MisOpen}
          onClose={() => {
            setMisOpen(false);
          }}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Edit Task</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex
                width={'100%'}
                direction={'column'}
                justifyContent={'space-between'}
                alignItems={'center'}
                gap={4}
              >
                <FormControl>
                  <FormLabel fontSize={'sm'}>Task name</FormLabel>
                  <Input
                    placeholder="Task name"
                    id="taskName1"
                    required
                    defaultValue={processTaskValue(ModalRowData.header)}
                  />
                </FormControl>
                <Flex gap={2} width={'100%'}>
                  <FormControl flex={1}>
                    <FormLabel fontSize={'sm'}>Assigned To</FormLabel>
                    <Select
                      width="100%"
                      id="owner1"
                      placeholder={ModalRowData.ownerName}
                      onChange={val => {
                        console.log(document.getElementById('owner1').value);
                      }}
                    >
                      {props.users !== undefined ? (
                        props.users.map(item => (
                          <option value={item.value}>{item.label}</option>
                        ))
                      ) : (
                        <></>
                      )}
                    </Select>
                  </FormControl>
                  <FormControl flex={1}>
                    <FormLabel fontSize={'sm'}>Due Date</FormLabel>
                    <Input
                      placeholder="Due Date"
                      type="date"
                      id="dueOn1"
                      required
                      defaultValue={ModalRowData.dueDate}
                    />
                  </FormControl>
                </Flex>
                <FormControl>
                  <FormLabel fontSize={'sm'}>Description</FormLabel>
                  <Textarea
                    placeholder="Desription"
                    id="desc1"
                    required
                    defaultValue={ModalRowData.description}
                  ></Textarea>
                </FormControl>
              </Flex>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => {
                  setExpandedRowKeys([]);
                  props.modify(ModalRowData);
                  setMisOpen(!MisOpen);
                }}
              >
                Save
              </Button>
              <Button
                onClick={() => {
                  setMisOpen(!MisOpen);
                }}
              >
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Table
          width={'100%'}
          height={400}
          data={getData(props)}
          rowKey={rowKey}
          expandedRowKeys={expandedRowKeys}
          renderRowExpanded={renderRowExpanded}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          loading={props.loading}
          shouldUpdateScroll={false}
          bordered
          cellBordered
          affixHorizontalScrollbar
          virtualized
          autoHeight
        >
          <Column align="center" resizable fixed>
            <HeaderCell>#</HeaderCell>
            <ExpandCell
              dataKey="id"
              expandedRowKeys={expandedRowKeys}
              onClick={handleExpanded}
            />
          </Column>

          <Column maxWidth={230} minWidth={150} resizable sortable>
            <HeaderCell>Assigned to</HeaderCell>
            <Cell dataKey="firstName" />
          </Column>

          <Column maxWidth={230} minWidth={150} resizable flexGrow={1} sortable>
            <HeaderCell>Task</HeaderCell>
            <Cell dataKey="header">
              {rowData => processTaskValue(rowData.header)}
            </Cell>
          </Column>
          <Column maxWidth={100} minWidth={150} resizable flexGrow={1} sortable>
            <HeaderCell>Due Date</HeaderCell>
            <Cell dataKey="dueDate" />
          </Column>
          <Column
            maxWidth={'100%'}
            minWidth={150}
            sortable
            resizable
            flexGrow={1}
            align="center"
          >
            <HeaderCell>Status</HeaderCell>
            <Cell dataKey="status">
              {rowData => (
                <Tag
                  color={
                    rowData.status === 'Completed'
                      ? 'green'
                      : rowData.status === 'Cancelled'
                        ? 'orange'
                        : rowData.status === 'In Progress'
                          ? 'yellow'
                          : 'red'
                  }
                >
                  {rowData.status}
                </Tag>
              )}
            </Cell>
          </Column>
        </Table>
      </>
    );
  } else {
    <></>;
  }
}

// Function to extract priority from task description using regex
const extractPriorityFromDescription = description => {
  if (!description) return 'Medium'; // Default priority if no description

  // Regex to match "Priority: X" where X is the priority level
  const priorityMatch = description.match(/Priority:\s*(High|Medium|Low)/i);

  // Return the matched priority or default to Medium if not found
  return priorityMatch ? priorityMatch[1] : 'Medium';
};

// Function to determine tag variant based on priority
const getPriorityVariant = priority => {
  const priorityLower = priority.toLowerCase();

  if (priorityLower === 'high') return 'danger';
  if (priorityLower === 'medium') return 'warning';
  if (priorityLower === 'low') return 'info';

  return 'warning'; // Default to warning for unknown priorities
};

// Reskinned Task Table component using Nexus components
function ReskinnedTaskTable(props) {
  useNexus(); // Initialize Nexus context
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState('dueDate');
  const [sortType, setSortType] = useState('desc');
  const [loading, setLoading] = React.useState(props.loading);
  // Store the current direction for each column
  const [columnDirections, setColumnDirections] = useState({
    firstName: TableSortDirection.ascending,
    header: TableSortDirection.ascending,
    dueDate: TableSortDirection.descending, // Set initial direction to descending for dueDate
    status: TableSortDirection.ascending,
    priority: TableSortDirection.descending, // Add priority column direction
  });

  // This function sorts the data based on the current sortColumn and sortType
  const getData = value => {
    if (sortColumn && sortType) {
      return [...value.data].sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];

        // Special handling for dueDate column to sort dates properly
        if (sortColumn === 'dueDate') {
          // Convert string dates to Date objects for proper comparison
          const dateX = x ? new Date(x) : new Date(0); // Default to epoch if null/undefined
          const dateY = y ? new Date(y) : new Date(0);

          // Compare the dates
          if (sortType === 'asc') {
            return dateX - dateY;
          } else {
            return dateY - dateX;
          }
        }

        // Special handling for status column to sort in a specific order
        if (sortColumn === 'status') {
          // Define the order of statuses (from highest to lowest priority)
          const statusOrder = {
            Completed: 1,
            'In Progress': 2,
            Cancelled: 3,
            'Not yet Started': 4,
          };

          // Get the numeric value for each status
          const xValue = statusOrder[x] || 999; // Default high value for unknown statuses
          const yValue = statusOrder[y] || 999;

          // Sort based on the numeric values
          return sortType === 'asc' ? xValue - yValue : yValue - xValue;
        }

        // Special handling for priority column to sort in a specific order
        if (sortColumn === 'priority') {
          // Define the order of priorities (from highest to lowest)
          const priorityOrder = {
            High: 1,
            Medium: 2,
            Low: 3,
          };

          // Extract priorities from descriptions
          const xPriority = extractPriorityFromDescription(a.description);
          const yPriority = extractPriorityFromDescription(b.description);

          // Get the numeric value for each priority
          const xValue = priorityOrder[xPriority] || 999;
          const yValue = priorityOrder[yPriority] || 999;

          // Sort based on the numeric values
          return sortType === 'asc' ? xValue - yValue : yValue - xValue;
        }

        // Handle string values properly with localeCompare
        if (typeof x === 'string' && typeof y === 'string') {
          return sortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
        }

        // Handle numeric values
        if (sortType === 'asc') {
          return x - y;
        } else {
          return y - x;
        }
      });
    }

    return value.data;
  };

  // This function handles sorting when a column header is clicked
  const handleSort = column => {
    // Toggle the direction for the clicked column
    const newDirection =
      columnDirections[column] === TableSortDirection.ascending
        ? TableSortDirection.descending
        : TableSortDirection.ascending;

    // Update the direction for this column
    setColumnDirections({
      ...columnDirections,
      [column]: newDirection,
    });

    // Convert Nexus TableSortDirection to 'asc'/'desc' string
    const sortTypeValue =
      newDirection === TableSortDirection.ascending ? 'asc' : 'desc';

    // Call the handleSortColumn logic with the new sort type
    handleSortColumn(column, sortTypeValue);
  };

  // This function handles sorting similar to the original table's handleSortColumn function
  const handleSortColumn = (newSortColumn, newSortType) => {
    props.setLoading(true);

    if (newSortColumn === 'dueDate') {
      // For dueDate column, we need to fetch from the server
      props.retrieveData(newSortType);
      setSortColumn(newSortColumn);
      setSortType(newSortType);
    } else {
      // For other columns, we sort client-side
      setTimeout(() => {
        setSortColumn(newSortColumn);
        setSortType(newSortType);
        props.setLoading(false);
      }, 500);
    }
  };

  // Function to open the drawer with the selected task
  const openTaskDrawer = task => {
    setSelectedTask(task);
    setIsDrawerOpen(true);
  };

  // Function to close the drawer
  const closeTaskDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleEditClick = task => {
    setSelectedTask(task);
    setIsModalOpen(true);
  };

  const modifyTask = () => {
    if (!selectedTask) return;

    const taskName = document.getElementById('nexus-edit-taskName').value;
    let taskDesc = document.getElementById('nexus-edit-desc').value;
    const ownerId = document.getElementById('nexus-edit-owner').value;
    const dueDate = document.getElementById('nexus-edit-dueOn').value;
    const status = document.getElementById('nexus-edit-status').value;
    const priority = document.getElementById('nexus-edit-priority').value;

    // Update the priority in the task description
    const currentPriority = extractPriorityFromDescription(
      selectedTask.description
    );

    // If the priority has changed, update it in the description
    if (currentPriority !== priority) {
      // Check if the description already has a Priority section
      if (taskDesc.includes('Priority:')) {
        // Replace the existing priority
        taskDesc = taskDesc.replace(
          /Priority:\s*(High|Medium|Low)/i,
          `Priority: ${priority}`
        );
      } else {
        // Add a new Priority section at the end of the description
        taskDesc = taskDesc.trim() + `\n\nPriority: ${priority}`;
      }
    }

    try {
      // Create a FormData object to send to the API
      const taskData = new FormData();
      taskData.append('task_title', taskName);
      taskData.append('task_desc', taskDesc);
      taskData.append('assigned_to', ownerId);
      taskData.append('status', status);
      taskData.append('due_on', dueDate);
      taskData.append('taskId', selectedTask.id);
      taskData.append('action', 'modify');

      // Set loading state
      props.setLoading(true);

      // Make the API call directly
      fetchWithAuth('/api/modify_task/', {
        method: 'POST',
        body: taskData,
      })
        .then(response => response.json())
        .then(() => {
          // Refresh the task list
          props.retrieveData();

          // Show success toast notification
          showToast({
            priority: 'success',
            content: 'Task updated successfully',
            autoClose: 6000,
          });

          // Close the modal and reset selected task
          setIsModalOpen(false);
          setSelectedTask(null);
        })
        .catch(error => {
          console.error('Error updating task:', error);

          // Show error toast notification
          showToast({
            priority: 'error',
            content:
              'Failed to update task: ' + (error.message || 'Unknown error'),
            autoClose: 6000,
          });
        })
        .finally(() => {
          props.setLoading(false);
        });
    } catch (error) {
      // Show error toast notification for any other errors
      showToast({
        priority: 'error',
        content: 'Failed to update task: ' + (error.message || 'Unknown error'),
        autoClose: 6000,
      });
      props.setLoading(false);
    }
  };

  // Function to handle task status updates
  const modifyTaskStatus = (task, action, status) => {
    if (!task) return;

    // Store the old status before making the change
    const oldStatus = task.status;

    // Create a FormData object to send to the API
    const taskData = new FormData();
    taskData.append('taskId', task.id);
    taskData.append('action', action);
    taskData.append('status', status);

    // Make the API call directly
    fetchWithAuth('/api/modify_task/', {
      method: 'POST',
      body: taskData,
    })
      .then(response => response.json())
      .then(() => {
        // Track task status change in Heap
        trackTaskStatusChanged({
          taskId: task.id,
          taskTitle: task.header || task.task_title || '',
          oldStatus: oldStatus || '',
          newStatus: status,
        });

        // Refresh the task list
        props.retrieveData();
      })
      .catch(error => {
        console.error('Error updating task status:', error);
      });
  };

  // Reference for the table container to handle scroll events
  const tableContainerRef = React.useRef(null);

  // Effect to initialize the sort order when the component mounts
  React.useEffect(() => {
    // Call retrieveData with 'desc' to sort by due date in descending order
    props.retrieveData('desc');
  }, [props.retrieveData]);

  // Effect to handle scroll events for the table container
  React.useEffect(() => {
    const handleScroll = () => {
      const container = tableContainerRef.current;
      if (!container) return;

      // Add 'scrolled-right' class when scrolled to the right
      if (container.scrollLeft > 0) {
        container.classList.add('scrolled-right');
      } else {
        container.classList.remove('scrolled-right');
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);

      // Initial check
      handleScroll();

      return () => {
        container.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  // We don't need the getSortedData function anymore since we're using getData
  // which matches the original table's sorting behavior

  const getStatusTag = status => {
    let color;
    let icon;

    switch (status) {
      case 'Completed':
        color = 'success';
        icon = completedSvg;
        break;
      case 'Cancelled':
        color = 'warning';
        icon = cancelledSvg;
        break;
      case 'In Progress':
        color = 'info';
        icon = inProgressSvg;
        break;
      default:
        color = 'danger';
        icon = todoSvg;
    }

    return (
      <NexusTag color={color} style={{ padding: '4px 8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <img
            src={icon}
            alt={status}
            style={{ width: '16px', height: '16px', verticalAlign: 'middle' }}
          />
          <span style={{ verticalAlign: 'middle' }}>
            {status === 'Not yet Started' ? 'To Do' : status}
          </span>
        </div>
      </NexusTag>
    );
  };

  return (
    <>
      <div
        ref={tableContainerRef}
        className="nexus-task-table-container"
        style={{
          position: 'relative',
          overflow: 'auto',
        }}
      >
        <NexusTable style={{ tableLayout: 'fixed', width: '100%' }}>
          <TableHead className="nexus-task-table-header">
            <TableRow>
              <TableHeaderSortCell
                onSort={() => handleSort('dueDate')}
                sortDirection={
                  sortColumn === 'dueDate'
                    ? columnDirections.dueDate
                    : undefined
                }
                style={{ width: '120px', minWidth: '120px' }}
              >
                Due Date
              </TableHeaderSortCell>
              <TableHeaderSortCell
                onSort={() => handleSort('priority')}
                sortDirection={
                  sortColumn === 'priority'
                    ? columnDirections.priority
                    : undefined
                }
                style={{ width: '80px', minWidth: '80px' }}
              >
                Priority
              </TableHeaderSortCell>
              <TableHeaderSortCell
                onSort={() => handleSort('firstName')}
                sortDirection={
                  sortColumn === 'firstName'
                    ? columnDirections.firstName
                    : undefined
                }
                style={{ width: '120px', minWidth: '120px' }}
              >
                Assigned to
              </TableHeaderSortCell>
              <TableHeaderSortCell
                onSort={() => handleSort('header')}
                sortDirection={
                  sortColumn === 'header' ? columnDirections.header : undefined
                }
                style={{ width: '240px', minWidth: '240px' }}
              >
                Task
              </TableHeaderSortCell>
              <TableHeaderSortCell
                onSort={() => handleSort('status')}
                sortDirection={
                  sortColumn === 'status' ? columnDirections.status : undefined
                }
                style={{ width: '120px', minWidth: '120px' }}
              >
                Status
              </TableHeaderSortCell>
              <TableHeaderCell style={{ width: '120px', minWidth: '120px' }}>
                Actions
              </TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody
            loadingView={
              props.loading ? (
                <div className="nexus-loading">Loading tasks...</div>
              ) : undefined
            }
          >
            {props.data &&
              getData({ data: props.data }).map(task => (
                <TableRow
                  key={task.id}
                  onClick={() => openTaskDrawer(task)}
                  style={{ cursor: 'pointer' }}
                  className="nexus-task-table-row"
                >
                  <TableCell
                    style={{
                      width: '120px',
                      minWidth: '120px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: '1rem',
                    }}
                  >
                    {task.dueDate || '--'}
                  </TableCell>
                  <TableCell
                    style={{
                      width: '80px',
                      minWidth: '80px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {task.description ? (
                      <NexusTag
                        variant={getPriorityVariant(
                          extractPriorityFromDescription(task.description)
                        )}
                        size="small"
                        className="nexus-priority-tag"
                      >
                        {extractPriorityFromDescription(task.description) ===
                        'Medium'
                          ? 'Med'
                          : extractPriorityFromDescription(task.description)}
                      </NexusTag>
                    ) : (
                      '--'
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      width: '120px',
                      minWidth: '120px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: '1rem',
                    }}
                  >
                    {task.firstName || '--'}
                  </TableCell>
                  <TableCell
                    style={{
                      width: '240px',
                      minWidth: '240px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      fontSize: '1rem',
                    }}
                  >
                    {processTaskValue(task.header) || '--'}
                  </TableCell>
                  <TableCell
                    style={{
                      width: '120px',
                      minWidth: '120px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    className="nexus-task-table-status-cell"
                  >
                    {task.status ? getStatusTag(task.status) : '--'}
                  </TableCell>
                  <TableActionsCell
                    style={{ width: '120px', minWidth: '120px' }}
                    onClick={e => e.stopPropagation()} // Prevent row click when clicking on actions
                  >
                    <ActionMenu
                      options={[
                        {
                          label: 'Edit Task',
                          onClick: () => handleEditClick(task),
                        },
                        {
                          label: 'Cancel Task',
                          onClick: () => {
                            if (task.status === 'Not yet Started') {
                              try {
                                props.handleDel(task.id);
                                showToast({
                                  priority: 'success',
                                  content: 'Task cancelled successfully',
                                  autoClose: 6000,
                                });
                              } catch (error) {
                                showToast({
                                  priority: 'error',
                                  content:
                                    'Failed to cancel task: ' +
                                    (error.message || 'Unknown error'),
                                  autoClose: 6000,
                                });
                              }
                            } else {
                              showToast({
                                priority: 'error',
                                content:
                                  'Only tasks with "Not yet Started" status can be cancelled',
                                autoClose: 6000,
                              });
                            }
                          },
                          isDisabled: task.status !== 'Not yet Started',
                        },
                      ]}
                    >
                      {({ getRootProps }) => (
                        <NexusIconButton
                          {...getRootProps()}
                          icon={MoreVerticalIcon}
                          label="More"
                          variant="text"
                          size="small"
                        />
                      )}
                    </ActionMenu>
                  </TableActionsCell>
                </TableRow>
              ))}
          </TableBody>
        </NexusTable>
      </div>

      {/* Edit Task Modal */}
      <NexusModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedTask(null);
        }}
        title="Edit Task"
        className="nexus-task-modal"
      >
        <NexusModalBody>
          {selectedTask && (
            <>
              <div className="nexus-form-group">
                <label htmlFor="nexus-edit-taskName">Task name</label>
                <input
                  type="text"
                  id="nexus-edit-taskName"
                  placeholder="Task name"
                  defaultValue={processTaskValue(selectedTask.header)}
                  required
                />
              </div>

              <div className="nexus-form-row">
                <div className="nexus-form-group">
                  <label htmlFor="nexus-edit-owner">Assigned To</label>
                  <select
                    id="nexus-edit-owner"
                    defaultValue={
                      props.users &&
                      props.users.find(u => u.label === selectedTask.ownerName)
                        ?.value
                    }
                  >
                    {props.users &&
                      props.users.map((user, index) => (
                        <option key={index} value={user.value}>
                          {user.label}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="nexus-form-group">
                  <label htmlFor="nexus-edit-dueOn">Due Date</label>
                  <input
                    type="date"
                    id="nexus-edit-dueOn"
                    defaultValue={selectedTask.dueDate}
                    required
                  />
                </div>
              </div>

              <div className="nexus-form-group">
                <label htmlFor="nexus-edit-status">Status</label>
                <select
                  id="nexus-edit-status"
                  defaultValue={selectedTask.status}
                >
                  <option value="Not yet Started">Not yet Started</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Completed">Completed</option>
                  <option value="Cancelled">Cancelled</option>
                </select>
              </div>

              <div className="nexus-form-group">
                <label htmlFor="nexus-edit-priority">Priority</label>
                <select
                  id="nexus-edit-priority"
                  defaultValue={extractPriorityFromDescription(
                    selectedTask.description
                  )}
                >
                  <option value="High">High</option>
                  <option value="Medium">Medium</option>
                  <option value="Low">Low</option>
                </select>
              </div>

              <div className="nexus-form-group">
                <label htmlFor="nexus-edit-desc">Description</label>
                <textarea
                  id="nexus-edit-desc"
                  placeholder="Description"
                  defaultValue={processTaskValue(selectedTask.description)}
                  required
                ></textarea>
              </div>
            </>
          )}
        </NexusModalBody>

        <NexusModalFooter>
          <NexusButton
            variant="tonal"
            onClick={() => {
              setIsModalOpen(false);
              setSelectedTask(null);
            }}
          >
            Cancel
          </NexusButton>
          <NexusButton onClick={modifyTask}>Save</NexusButton>
        </NexusModalFooter>
      </NexusModal>

      {/* Task Drawer */}
      <TaskDrawer
        selectedTask={selectedTask}
        isDrawerOpen={isDrawerOpen}
        onClose={closeTaskDrawer}
        modifyTasks={modifyTaskStatus}
        fetchTasks={props.retrieveData}
        isFromTaskTable={true}
      />
    </>
  );
}

// Main export function that conditionally renders the appropriate component based on the feature flag
export default function TaskTable(props) {
  // Check if the showReskin feature flag is enabled
  const showReskin = useFeatureFlagFromContext('showReskin', false);

  // Render the appropriate component based on the feature flag
  return showReskin ? (
    <ReskinnedTaskTable {...props} />
  ) : (
    <OriginalTaskTable {...props} />
  );
}
